import { compact, toArray, difference } from 'lodash-es'

import MapSimple from '../utils/map-simple'
import ResizeDetector from '../utils/resize-detector'

const OBSERVE_INTERVAL = 300

export default function ChildResizeDetector(target, callback) {
  let wait = null
  let observer = null
  const map = MapSimple()
  init()

  return {
    destroy
  }

  function init() {
    wait = setTimeout(() => {
      observer = ChildObserver(target, refresh)
      reattach()
    }, 0)
  }

  function destroy() {
    clearTimeout(wait)
    wait = null

    if (observer) {
      observer.disconnect()
      observer = null
    }

    map.values().forEach(detectorOff)
    map.clear()
  }

  function refresh() {
    reattach()
    callback()
  }

  function reattach() {
    const actElms = compact([target, ...toArray(target.children)])
    const outElms = map.keys()
    const delElms = difference(outElms, actElms)
    const newElms = difference(actElms, outElms)

    for (const delElm of delElms) {
      const detector = map.get(delElm)
      detectorOff(detector)
      map.del(delElm)
    }

    for (const newElm of newElms) {
      const detector = ResizeDetector(newElm)
      detectorOn(detector)
      map.set(newElm, detector)
    }
  }

  function detectorOn(detector) {
    return detector.on(callback)
  }

  function detectorOff(detector) {
    return detector.off(callback)
  }
}

function ChildObserver(target, callback) {
  if (!window.MutationObserver) {
    console.warn('ChildObserver: MutationObserver is not available will use interval mode!')
    let last = toArray(target.children)
    const id = setInterval(() => {
      const curr = toArray(target.children)
      const cond = true
        && curr.length === last.length
        && curr.every((c) => last.some((l) => l === c))
      last = curr
      if (!cond) callback()
    }, OBSERVE_INTERVAL)
    return { disconnect: () => clearInterval(id) }
  } else {
    const observer = new window.MutationObserver(callback)
    const config = { childList: true }
    observer.observe(target, config)
    return observer
  }
}
